import api from "../utils/api";
export default async function get(url, header, query) {
    const response = await api.get(url, {
        headers: header,
        params: query,
    });
    return response.data;
}
